import { lazy } from "react";

export const Leaderboard = lazy(() => import("pages/leaderboard"));
export const NewFeeds = lazy(() => import("pages/newsFeed"));
export const Account = lazy(() => import("pages/account"));
export const Settings = lazy(() => import("pages/settings")); // Workspace (renamed)
export const Billing = lazy(() => import("pages/billing"));
export const SignIn = lazy(() => import("pages/signIn"));
export const Insights = lazy(() => import("pages/insights"));
export const Customization = lazy(() => import("pages/customization"));
export const PublicProfile = lazy(() => import("pages/publicProfile"));
export const HelpCenter = lazy(() => import("pages/helpCenter"));
export const SuperAdminPanel = lazy(() => import("pages/superAdmin"));
export const SuperAdminSignIn = lazy(() => import("pages/superAdminLogin"));
export const SettingsCompanyValues = lazy(
  () => import("pages/settings/companyValuesView")
);
export const ScheduleReport = lazy(
  () => import("pages/settings/scheduleReportView")
);
export const SettingsMembers = lazy(() => import("pages/settings/membersView"));
export const SettingsSubscription = lazy(
  () => import("pages/settings/subscriptionView")
);
export const PrivacyPolicy = lazy(() => import("pages/privacyPolicy"));
export const TermsOfService = lazy(() => import("pages/termsOfService"));
export const OverviewDashboard = lazy(
  () => import("pages/analytics/overview-dashboard")
);
export const EmployeeInsights = lazy(
  () => import("pages/analytics/employee-insights")
);
export const TeamAnalysis = lazy(() => import("pages/analytics/team-analysis"));
export const RecognitionTrends = lazy(
  () => import("pages/analytics/recognition-trends")
);
export const LowEngagement = lazy(
  () => import("pages/analytics/low-engagement")
);
export const SettingsActions = lazy(() => import("pages/settings/actionsView"));
export const ActionsPage = lazy(() => import("pages/actions"));
export const SubmitClaimPage = lazy(() => import("pages/actions/submitClaim"));
export const MyClaimsPage = lazy(() => import("pages/actions/myClaims"));
export const AdminClaimsPage = lazy(() => import("pages/actions/adminClaims"));
export const SettingsBadges = lazy(() => import("pages/settings/badgesView"));
